import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { useEffect } from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Landing from "@/pages/Landing";
import QueEsPastaBase from "@/pages/QueEsPastaBase";
import Efectos from "@/pages/Efectos";
import TestDependencia from "@/pages/TestDependencia";
import Tratamientos from "@/pages/Tratamientos";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import PreguntasFrecuentes from "@/pages/PreguntasFrecuentes";
import Nosotros from "@/pages/Nosotros";
import NotFound from "@/pages/NotFound";
import { Toaster } from "@/components/ui/sonner";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function Shell() {
  return (
    <div className="App flex min-h-screen flex-col bg-slate-950 text-slate-50">
      <Header />
      <main className="flex-1" data-testid="main-content">
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/que-es-pasta-base" element={<QueEsPastaBase />} />
          <Route path="/efectos" element={<Efectos />} />
          <Route path="/test-dependencia" element={<TestDependencia />} />
          <Route path="/tratamientos" element={<Tratamientos />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/preguntas-frecuentes" element={<PreguntasFrecuentes />} />
          <Route path="/nosotros" element={<Nosotros />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Shell />
        <Toaster richColors position="top-center" />
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
